import { Tooltip } from "antd";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { LOG_TYPE } from "../contants";
import { WorkerLogtimeData } from "@lhd/types";
import { useTrackingCompanyId } from "../useTrackingCompanyId";
import {
  StyleSelect,
  TRACKING_COMPANY_SELECT_DROPDOWN_CLASS,
  TrackingCompanySelectDropdownStyles,
} from "./styled";

const MOBILE_COMPANY_LIST_HEIGHT = 200;

const lockBodyScroll = (scrollY: number) => {
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
};

const unlockBodyScroll = (scrollY: number) => {
  document.body.style.overflow = "";
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";
  window.scrollTo(0, scrollY);
};

interface IProps {
  className?: string;
  workerLogtimesData?: WorkerLogtimeData;
}

const SelectCompany = (props: IProps) => {
  const { className, workerLogtimesData } = props;
  const { companies, selectedCompanyId, onCompanyChange, isSwitchingCompany } =
    useTrackingCompanyId();
  const scrollYRef = useRef(0);
  const isDropdownOpenRef = useRef(false);

  useEffect(() => {
    return () => {
      if (isDropdownOpenRef.current) {
        unlockBodyScroll(scrollYRef.current);
        isDropdownOpenRef.current = false;
      }
    };
  }, []);

  const onDropdownVisibleChange = useCallback((open: boolean) => {
    if (open) {
      scrollYRef.current = window.scrollY;
      lockBodyScroll(scrollYRef.current);
      isDropdownOpenRef.current = true;
      return;
    }
    isDropdownOpenRef.current = false;
    unlockBodyScroll(scrollYRef.current);
  }, []);

  const lastLog = workerLogtimesData?.today_logs?.at(-1);
  const options = useMemo(
    () =>
      companies.map((c) => ({
        value: c.id.toString(),
        label: c.name,
      })),
    [companies],
  );
  const disabled = Boolean(
    lastLog?.log_type && lastLog.log_type !== LOG_TYPE.CHECKOUT,
  );

  return (
    <>
      <TrackingCompanySelectDropdownStyles />
      <Tooltip
        title="すでに出勤中のため、他の会社に移動できません。"
        open={disabled ? undefined : false}
        color="red"
        trigger="click"
        key={String(disabled)}
      >
        <StyleSelect
          disabled={disabled}
          loading={isSwitchingCompany}
          options={options}
          value={selectedCompanyId || undefined}
          onChange={(value) => onCompanyChange(String(value))}
          onDropdownVisibleChange={onDropdownVisibleChange}
          dropdownClassName={TRACKING_COMPANY_SELECT_DROPDOWN_CLASS}
          listHeight={MOBILE_COMPANY_LIST_HEIGHT}
          className={className || ""}
        />
      </Tooltip>
    </>
  );
};

export default SelectCompany;
